import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20modern%20technology%20background%20with%20flowing%20organic%20shapes%20in%20warm%20amber%20and%20soft%20cream%20tones%2C%20representing%20website%20creation%20and%20digital%20creativity%2C%20clean%20minimalist%20aesthetic%20with%20subtle%20geometric%20patterns%2C%20professional%20SaaS%20atmosphere%2C%20soft%20gradient%20lighting%2C%20ethereal%20and%20inspiring%2C%20high%20quality%203D%20render%20style&width=1600&height=900&seq=hero-bg-main&orientation=landscape"
          alt="免费在线成网站 - 零成本快速建站平台"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/50"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 max-w-5xl mx-auto text-center py-20">
        <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-background-50/20 backdrop-blur-sm border border-background-50/30 mb-8">
          <i className="ri-sparkling-line text-primary-300 text-sm"></i>
          <span className="text-sm text-background-50/90 font-medium">已服务超过 50 万用户</span>
        </div>

        <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-background-50 leading-tight mb-6 font-heading">
          免费在线成网站
          <br />
          <span className="text-primary-300">零成本快速建站平台</span>
        </h1>

        <p className="text-base md:text-lg text-background-50/80 max-w-2xl mx-auto mb-10 leading-relaxed">
          无需编程知识，AI智能驱动，一键生成专业网站。个人博客、企业官网、电商页面，只需几分钟即可完成。真正零成本，让每个人都能轻松拥有自己的网站。
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="#cta"
            className="w-full sm:w-auto px-8 py-3.5 rounded-full bg-primary-500 text-background-50 text-base font-semibold hover:bg-primary-400 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            立即免费建站
            <i className="ri-arrow-right-line ml-2"></i>
          </a>
          <Link
            to="/category/all"
            className="w-full sm:w-auto px-8 py-3.5 rounded-full bg-background-50/15 backdrop-blur-sm border border-background-50/30 text-background-50 text-base font-medium hover:bg-background-50/25 transition-all duration-300 whitespace-nowrap"
          >
            浏览模板库
            <i className="ri-eye-line ml-2"></i>
          </Link>
        </div>

        <div className="mt-16 flex items-center justify-center gap-8 text-background-50/60 text-sm">
          <div className="flex items-center gap-2">
            <i className="ri-checkbox-circle-line text-accent-400 text-base"></i>
            <span>零成本</span>
          </div>
          <div className="flex items-center gap-2">
            <i className="ri-checkbox-circle-line text-accent-400 text-base"></i>
            <span>无需编程</span>
          </div>
          <div className="flex items-center gap-2">
            <i className="ri-checkbox-circle-line text-accent-400 text-base"></i>
            <span>几分钟上线</span>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-s-line text-2xl text-background-50/60"></i>
      </div>
    </section>
  );
}